import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TableDetailsResponseDto } from './dto/table-details-dto';
import { ApiResponseDto } from './dto/api-response-dto';

export interface CartItemDto {
  idi: number;
  id: number;
  qty: number;
  price: number;
  total: number;
  name: string;
  choices?: any[];
  additional_info?: string;
}

export interface AddCartItemsDto {
  uuid: string;
  total: number;
  clientId: number;
  userId?: number;
  items: CartItemDto[];
}

export interface ApplyVoucherDto {
  idi: number;
  userId: number;
  cartId: number;
  voucherCode: string;
  cartTotal: number;
}

export interface ApplyVoucherResponseDto {
  id: number;
  voucherId: number;
  voucherName: string;
  discountType: string;
  discountValue: number;
  discountValueApplied: number;
}

export interface RemoveVoucherDto {
  idi: number;
  cartId: number;
  voucherId: number;
  userId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class TableApiService {

  constructor(private http: HttpClient) { }

  getTableData(uuid: string, cartUuid?: string): Observable<TableDetailsResponseDto> {
    const session: string = cartUuid ? `?session=${cartUuid}` : '';
    return this.http.get<TableDetailsResponseDto>(`qrcode/${uuid}${session}`);
  }

  submitCartItems(tableId: number, dto: AddCartItemsDto): Observable<ApiResponseDto> {
    return this.http.post<ApiResponseDto>(`tables/${tableId}/cart/items`, dto);
  }

  callWaiter(tableId: number): Observable<ApiResponseDto> {
    return this.http.post<ApiResponseDto>(`tables/${tableId}/call-waiter`, {});
  }

  applyVoucher(dto: ApplyVoucherDto): Observable<ApplyVoucherResponseDto> {
    return this.http.post<ApplyVoucherResponseDto>(`voucher/apply`, dto);
  }

  removeVoucher(dto: RemoveVoucherDto): Observable<any> {
    return this.http.delete<any>(`voucher/remove`, { body: dto });
  }
}
